<template>
  <div>
    <!-- waardeontwikkeling -->
    <div class="card">
      <div class="print">
        <img class="db-logo" src="../../../assets/db/DB-logo1.svg" />

        <h2 class="title">Samenstelling portefeuille</h2>
        <p style="line-height: 150%">
          Doelbeleggen.nl werkt met 5 verschillende profielen en bijbehorende
          beleggingsportefeuilles. Ieder beleggingsprofiel heeft een eigen portefeuille met zijn
          eigen beleggingskarakter en haalbaarheid van uw doelstelling.
        </p>

        <div class="scroll-container">
          <table class="transparent-table fat-liner">
            <colgroup>
              <col class="unselected-profile"/>
              <col :class="profile === 'A' ? 'selected-profile' : 'unselected-profile'" />
              <col :class="profile === 'B' ? 'selected-profile' : 'unselected-profile'" />
              <col :class="profile === 'C' ? 'selected-profile' : 'unselected-profile'" />
              <col :class="profile === 'D' ? 'selected-profile' : 'unselected-profile'" />
              <col :class="profile === 'E' ? 'selected-profile' : 'unselected-profile'" />
            </colgroup>
            <tr>
              <td style="width:150px">Beleggingsbeleid</td>
              <td>A</td>
              <td>B</td>
              <td>C</td>
              <td>D</td>
              <td>E</td>
            </tr>
            <tr>
              <td>Aandelen</td>
              <td>15%</td>
              <td>35%</td>
              <td>50%</td>
              <td>65%</td>
              <td>85%</td>
            </tr>
            <tr>
              <td>Vastgoed</td>
              <td>5%</td>
              <td>5%</td>
              <td>5%</td>
              <td>5%</td>
              <td>5%</td>
            </tr>
            <tr>
              <td>Obligaties</td>
              <td>75%</td>
              <td>55%</td>
              <td>40%</td>
              <td>25%</td>
              <td>5%</td>
            </tr>
            <tr>
              <td>Geldmarkt</td>
              <td>5%</td>
              <td>5%</td>
              <td>5%</td>
              <td>5%</td>
              <td>5%</td>
            </tr>
            <tr>
              <td>
                Verwacht rendement*
              </td>
              <td>3,1%</td>
              <td>4,1%</td>
              <td>4,8%</td>
              <td>5,5%</td>
              <td>6,5%</td>
            </tr>
            <tr>
              <td>
                Standaarddeviatie
              </td>
              <td>6,8%</td>
              <td>8,8%</td>
              <td>10,6%</td>
              <td>12,6%</td>
              <td>15,4%</td>
            </tr>
          </table>
        </div>

        <template v-if="offerTypeShort === 'opbouwend'">
          <h2 class="title">Waardeontwikkeling</h2>
          <p style="line-height: 150%">
            U ziet hieronder een overzicht van de waardeontwikkeling, tussentijdse
            waardenschommelingen en kansen op verlies over een 5-jaars, 10-jaars en 20-jaars
            periode. Wij nemen als startpunt € 10.000,-. In de vermogensverwachting ziet u
            informatie over een slechte, normale en goede markt van het voor u geselecteerde
            maximale beleggingsbeleid. Ondanks dat wij de prognoses en verwachtingen baseren op
            betrouwbaar geachte (statistische) uitgangspunten, is er geen garantie dat uw
            doelstelling daadwerkelijk behaald wordt.
          </p>
          <table v-if="profile === 'A'" class="transparent-table">
            <tr>
              <th>Doelbeleggen {{ profile }}<sup>*</sup></th>
              <th>5 jaar</th>
              <th>10 jaar</th>
              <th>20 jaar</th>
            </tr>
            <tr :style="`color: ${options2.colors[2]}`">
              <td>Goede markt</td>
              <td>&euro; 15.253 (52,5%)</td>
              <td>&euro; 20.799 (108%)</td>
              <td>&euro; 37.667 (277%)</td>
            </tr>
            <tr :style="`color: ${options2.colors[1]}`">
              <td>Normale markt</td>
              <td>&euro; 11.856 (18,6%)</td>
              <td>&euro; 14.565 (45,6%)</td>
              <td>&euro; 22.758 (128%)</td>
            </tr>
            <tr :style="`color: ${options2.colors[0]};`">
              <td>Slechte markt</td>
              <td>&euro; 9.216 (-7,84%)</td>
              <td>&euro; 10.199 (1,99%)</td>
              <td>&euro; 13.750 (37,5%)</td>
            </tr>
            <tr>
              <td style="width:150px">Kans op negatief rendement</td>
              <td>13,3%</td>
              <td>4,13%</td>
              <td>0,36%</td>
            </tr>
          </table>

          <table v-if="profile === 'B'" class="transparent-table">
            <tr>
              <th>Doelbeleggen {{ profile }}<sup>*</sup></th>
              <th>5 jaar</th>
              <th>10 jaar</th>
              <th>20 jaar</th>
            </tr>
            <tr :style="`color: ${options2.colors[2]}`">
              <td>Goede markt</td>
              <td>&euro; 17.088 (70,9%)</td>
              <td>&euro; 24.810 (148%)</td>
              <td>&euro; 49.619 (396%)</td>
            </tr>
            <tr :style="`color: ${options2.colors[1]}`">
              <td>Normale markt</td>
              <td>&euro; 12.372 (23,7%)</td>
              <td>&euro; 15.713 (57,1%)</td>
              <td>&euro; 26.008 (160%)</td>
            </tr>
            <tr :style="`color: ${options2.colors[0]};`">
              <td>Slechte markt</td>
              <td>&euro; 8.957 (-10,4%)</td>
              <td>&euro; 9.951 (-0,49%)</td>
              <td>&euro; 13.632 (36,3%)</td>
            </tr>
            <tr>
              <td style="width:150px">Kans op negatief rendement</td>
              <td>13,9%</td>
              <td>5,18%</td>
              <td>0,75%</td>
            </tr>
          </table>

          <table v-if="profile === 'C'" class="transparent-table">
            <tr>
              <th>Doelbeleggen {{ profile}}<sup>*</sup></th>
              <th>5 jaar</th>
              <th>10 jaar</th>
              <th>20 jaar</th>
            </tr>
            <tr :style="`color: ${options2.colors[2]}`">
              <td>Goede markt</td>
              <td>&euro; 18.864 (88,6%)</td>
              <td>&euro; 28.871 (189%)</td>
              <td>&euro; 62.694 (527%)</td>
            </tr>
            <tr :style="`color: ${options2.colors[1]}`">
              <td>Normale markt</td>
              <td>&euro; 12.770 (27,7%)</td>
              <td>&euro; 16.627 (66,3%)</td>
              <td>&euro; 28.728 (187%)</td>
            </tr>
            <tr :style="`color: ${options2.colors[0]};`">
              <td>Slechte markt</td>
              <td>&euro; 8.644 (-13,6%)</td>
              <td>&euro; 9.575 (-4,25%)</td>
              <td>&euro; 13.164 (31,6%)</td>
            </tr>
            <tr>
              <td style="width:150px">Kans op negatief rendement</td>
              <td>15,1%</td>
              <td>6,48%</td>
              <td>1,31%</td>
            </tr>
          </table>

          <table v-if="profile === 'D'" class="transparent-table">
            <tr>
              <th>Doelbeleggen {{ profile}}<sup>*</sup></th>
              <th>5 jaar</th>
              <th>10 jaar</th>
              <th>20 jaar</th>
            </tr>
            <tr :style="`color: ${options2.colors[2]}`">
              <td>Goede markt</td>
              <td>&euro; 20.952 (110%)</td>
              <td>&euro; 33.884 (239%)</td>
              <td>&euro; 80.176 (702%)</td>
            </tr>
            <tr :style="`color: ${options2.colors[1]}`">
              <td>Normale markt</td>
              <td>&euro; 13.178 (31,8%)</td>
              <td>&euro; 17.588 (75,9%)</td>
              <td>&euro; 31.718 (217%)</td>
            </tr>
            <tr :style="`color: ${options2.colors[0]}`">
              <td>Slechte markt</td>
              <td>&euro; 8.289 (-17,1%)</td>
              <td>&euro; 9.129 (-8,71%)</td>
              <td>&euro; 12.548 (25,5%)</td>
            </tr>
            <tr>
              <td style="width:150px">Kans op negatief rendement</td>
              <td>16,4%</td>
              <td>7,83%</td>
              <td>2,03%</td>
            </tr>
          </table>

          <table v-if="profile === 'E'" class="transparent-table">
            <tr>
              <th>Doelbeleggen {{ profile }}<sup>*</sup></th>
              <th>5 jaar</th>
              <th>10 jaar</th>
              <th>20 jaar</th>
            </tr>
            <tr :style="`color: ${options2.colors[2]}`">
              <td>Goede markt</td>
              <td>&euro; 24.255 (142%)</td>
              <td>&euro; 42.254 (323%)</td>
              <td>&euro; 112.435 (1024%)</td>
            </tr>
            <tr :style="`color: ${options2.colors[1]}`">
              <td>Normale markt</td>
              <td>&euro; 13.739 (37,4%)</td>
              <td>&euro; 18.947 (89,5%)</td>
              <td>&euro; 36.165 (262%)</td>
            </tr>
            <tr :style="`color: ${options2.colors[0]};`">
              <td>Slechte markt</td>
              <td>&euro; 7.792 (-22,1%)</td>
              <td>&euro; 8.496 (-15,0%)</td>
              <td>&euro; 11.632 (16,3%)</td>
            </tr>
            <tr>
              <td style="width:150px">Kans op negatief rendement</td>
              <td>17,8%</td>
              <td>5,36%</td>
              <td>3,12%</td>
            </tr>
          </table>

          <table class="graph-table">
            <tr>
              <th>Doelbeleggen {{ profile }}<sup>*</sup></th>
            </tr>
            <tr>
              <td colspan="4" class="chart">
                <GChart
                  :settings="{ packages: ['corechart'], language: 'nl-nl' }"
                  :data="[columns].concat(lineRows)"
                  :options="options2"
                  type="LineChart"
                />
              </td>
            </tr>
          </table>
        </template>
        <template
          v-else-if="[0, 1, 4, 5].includes(Number(offerType))"
        >
          <br />
          <h2 class="title">Verwacht verloop uitkering</h2>
          <p v-if="offerType === 1 || offerType === 4" style="line-height: 150%">
            Hieronder staat het verwachte verloop van de uitkeringen op jaarbasis. U ziet dat bij de
            {{ goalType }} de geschatte uitkering direct hoog start om vervolgens een aantal
            jaren erna mooi op te lopen. Na deze ingebouwde verhoging zijn de uitkeringen stabiel en
            weer op het niveau van de eerste uitkering.
          </p>
          <p v-else style="line-height: 150%">
            Hieronder staat het verwachte verloop van de uitkeringen op jaarbasis. U ziet dat na de
            start de geschatte uitkeringen met het Neutrale en het Optimistische verloop mooi
            oplopen. In het Pessimistische geval dalen de uitkeringen.
          </p>

          <div class="graph">
            <GChart
              :settings="{ packages: ['corechart'], language: 'nl-nl' }"
              :data="Number(offerType) === 0 || Number(offerType) === 5 ? results4 : results3"
              :options="options1"
              type="ComboChart"
            />
          </div>

        </template>
        <template v-else-if="Number(offerType) === 2 || Number(offerType) === 3">
          <br />
          <h2 class="title">Meer over uw Gouden handdruk beleggingsrekening</h2>
          <p v-if="Number(offerType) === 2" style="line-height: 150%">
            <!--Text for Vaste looptijd -->
            U krijgt over de looptijd elk jaar een andere uitkering. Het ene jaar is die hoger dan
            het andere jaar. Dit is afhankelijk van hoe het gaat met uw beleggingen. We bekijken
            ieder jaar hoe het ervoor staat. Op basis daarvan bepalen we uw nieuwe uitkering.
            Hieronder ziet u wat er gebeurt bij een stijging of daling van de beleggingen.
            <br /><br />
          </p>
          <p v-else-if="Number(offerType) === 3" style="line-height: 150%">
            <!--Text for Vaste uitkering -->
            U krijgt een vaste uitkering, maar de totale looptijd kan elk jaar veranderen. Het ene
            jaar is die hoger of lager dan het andere jaar. Dit is afhankelijk van hoe het gaat met
            uw beleggingen. We bekijken ieder jaar hoe het ervoor staat. Op basis daarvan bepalen we
            de nieuwe looptijd. Hieronder leest u wat er gebeurt bij een stijging of daling van de
            beleggingen.
            <br /><br />
          </p>
          <table class="transparent-table">
            <tr>
              <th>Beleggingen</th>
              <th>
                Effect op geschatte {{ Number(offerType) === 3 ? 'looptijd' : 'uitkering' }}
              </th>
            </tr>
            <tr>
              <td>Waarde neemt met <b>meer</b> dan het netto voorbeeldrendement per jaar toe</td>
              <td>Positief, deze stijgt</td>
            </tr>
            <tr>
              <td>
                Waarde neemt met <b>minder</b> dan het netto voorbeeldrendement per jaar toe
              </td>
              <td>Negatief, deze daalt</td>
            </tr>
          </table>
          <p style="line-height: 150%">
            <b>Wijzigen looptijd of hoogte van de uitkering</b><br />
            De keuze van de hoogte en de looptijd van de uitkering kunt u gedurende de gehele
            uitkeringsperiode wijzigen. Indien u binnen fiscale grenzen blijft, kan dit zelfs
            meerdere malen. Mogelijk dat uw bestedingspatroon in de loop der jaren door gewijzigde
            persoonlijke omstandigheden verandert. Misschien dat u bijvoorbeeld na 5 jaar uw
            uitkering wilt verhogen. Dat is geen probleem, meestal is het fiscaal toegestaan om de
            looptijd en de uitkering aan te passen. Wij zullen daar dan uiteraard aan meewerken.
            <br /><br />
            <b>Eenmalige uitkering</b><br />
            Na een aantal jaren een uitkering ontvangen te hebben kan het zijn dat u in één keer
            het resterende kapitaal wilt opnemen. Hoewel dit fiscaal vaak minder gunstig is (u
            ontvangt een hoger bedrag, dat zwaarder wordt belast) staat deze optie kosteloos voor
            u open.
          </p>
        </template>
      </div>
      <div class="docdate">
        {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div class="pagefooter">
        {{
          persoonsData.geslacht
            ? persoonsData.geslacht === 'man' ? 'de heer': 'mevrouw'
            : 'de heer/mevrouw'
        }}
        {{(persoonsData.roepnaam || persoonsData.voornaam) || '' }}
        {{ persoonsData.tussenvoegsel || '' }}
        {{ persoonsData.achternaam || '' }}
        <br />
        Indicatieve berekening {{ goalType }}
      </div>
      <div class="pagenumber"></div>
    </div>
  </div>
</template>

<script>
import { find } from 'lodash-es';

export default {
  props: {
    goalData: Object,
    persoonsData: Object,
    charts: Object,
    rendement: Number,
    offerType: {
      type: Number,
      required: true,
      default: 10,
    },
    today: {
      type: Date,
      default: () => new Date(),
    },
    profile: {
      type: String,
      default: 'C',
    },
  },
  data() {
    return {
      options1: {
        backgroundColor: { fill: 'transparent' },
        height: 275,
        legend: { position: 'top' },
        pointSize: 0,
        chartArea: {
          left: 65,
          top: 55,
          bottom: 40,
          right: 20,
          width: '100%',
          height: '100%',
        },
        hAxis: {
          title: 'Jaren',
          format: 'short',
          textStyle: { fontSize: 13 },
          gridlines: { color: '#eee' },
        },
        vAxis: {
          gridlines: { color: '#eee' },
          textStyle: { fontSize: 13 },
        },
        series: {
          0: { type: 'line', color: '#c1272d' },
          1: { type: 'line', color: '#67bf00' },
          2: { type: 'line', color: '#000066' },
        },
      },
      options2: {
        colors: ['#c1272d', '#006', '#6c0'],
        pointSize: 5,
        chartArea: {
          left: 50,
          right: 0,
          top: 5,
          bottom: 20,
          width: '100%',
          height: '100%',
        },
        height: 200,
        width: 600,
        curveType: 'function',
        backgroundColor: {
          fillOpacity: 0,
        },
      },
      columns: [
        {
          type: 'string',
          label: 'Jaar',
        },
        {
          type: 'number',
          label: 'Slechte Markt',
        },
        {
          type: 'number',
          label: 'Normale Markt',
        },
        {
          type: 'number',
          label: 'Goede Markt',
        },
      ],
    };
  },
  computed: {
    results3() {
      return [this.getCols3()].concat(this.charts.chart3);
    },
    results4() {
      return [this.getCols4()].concat(this.charts.chart4);
    },
    offerTypeShort() {
      if (
        this.goalData.type === 'gouden-handdruk-uitkerend'
        || this.goalData.type === 'netto-lijfrente-uitkerend'
        || (this.goalData.type === 'levensonderhoud' && this.goalData.box === '1')
      ) {
        return 'uitkerend';
      }
      return 'opbouwend';
    },
    goalType() {
      if (this.goalData.type === 'gouden-handdruk-opbouwend' || this.goalData.type === 'gouden-handdruk-uitkerend') {
        return 'Gouden handdruk';
      }
      if (this.goalData.type === 'netto-lijfrente-uitkerend') {
        return 'Netto lijfrente';
      }
      return 'Lijfrente';
    },
    lineRows() {
      if (this.profile === 'A') {
        return [
          ['5 jaar', 9216, 11856, 15253],
          ['10 jaar', 10199, 14565, 20799],
          ['20 jaar', 13750, 22758, 37667],
        ];
      }
      if (this.profile === 'B') {
        return [
          ['5 jaar', 8957, 12372, 17088],
          ['10 jaar', 9951, 15713, 24810],
          ['20 jaar', 13632, 26008, 49619],
        ];
      }
      if (this.profile === 'C') {
        return [
          ['5 jaar', 8644, 12770, 18864],
          ['10 jaar', 9575, 16627, 28871],
          ['20 jaar', 13164, 28728, 62694],
        ];
      }
      if (this.profile === 'D') {
        return [
          ['5 jaar', 8289, 13178, 20952],
          ['10 jaar', 9129, 17588, 33884],
          ['20 jaar', 12548, 31718, 80176],
        ];
      }
      if (this.profile === 'E') {
        return [
          ['5 jaar', 7792, 13739, 24255],
          ['10 jaar', 8496, 18947, 42254],
          ['20 jaar', 11632, 36165, 112435],
        ];
      }
      return false;
    },
  },
  methods: {
    find,
    getCols3() {
      const cols = [];
      cols.push({
        type: 'string',
        label: 'Jaar',
      });
      cols.push({
        type: 'number',
        label: 'Pessimistisch (-2%)',
      });
      cols.push({
        type: 'number',
        label: `Voorbeeldrendement (${this.rendement}%)`,
      });
      cols.push({
        type: 'number',
        label: 'Optimistisch (8%)',
      });
      return cols;
    },
    getCols4() {
      const cols = [];
      cols.push({
        type: 'string',
        label: 'Jaar',
      });
      cols.push({
        type: 'number',
        label: 'Pessimistisch (-2%)',
      });
      cols.push({
        type: 'number',
        label: `Voorbeeldrendement (${this.rendement}%)`,
      });
      cols.push({
        type: 'number',
        label: 'Optimistisch (8%)',
      });
      return cols;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../../../scss/_paper.scss";
  table {
    margin-top: 20px;
  }
  h2 {
    margin-top: 30px;
    &:first-child {
      margin-top: 0;
    }
  }
  .graph-table {
    tr {
      border-top: none;
      background-color: transparent;
      td:first-of-type {
        font-weight: bold;
      }
    }
  }
  .fat-liner {
    tr:nth-child(7) {
      font-style: italic;
      border-top: 1px solid $color-highlight;
    }
    tr:nth-child(8) {
      font-style: italic;
    }
  }
  .selected-profile {
    border: 1px solid $color-highlight;
    background-color: #A4D966;
  }
  .unselected-profile {
    background-color: #fff;
  }
  .situation-table {
    tr {
      background-color: transparent;
      td:first-of-type {
        font-weight: bold;
      }
    }
  }
  .transparent-table {
    tr {
      background-color: transparent;
    }
  }
</style>
